import { createAction } from "redux-actions";

export const addLoader = createAction("ADD_LOADER", actionName => ({ actionName }));
export const removeLoader = createAction("REMOVE_LOADER", actionName => ({ actionName }));
